module.exports = __webpack_public_path__ + "static/img/peekaboowoman.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/peekaboowoman.jpg
// module id = hTHc
// module chunks = 1